import React from 'react';
import styles from './Toast.module.css';

interface ToastProps {
    message: string;
    type: 'success' | 'error' | 'info';
}

const Toast: React.FC<ToastProps> = ({ message, type }) => (
    <div className={`${styles.toast} ${styles[type]}`} role="status">
        {message}
    </div>
);

export default Toast;
